<template>
  <div id="events-preview">
    <v-overlay :value="ProgressLoadingFlag">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- Premium Header with Title and Actions -->
    <div class="premium-header">
      <div class="header-content">
        <div class="title-section">
          <v-icon class="title-icon" color="#3A67B1">mdi-file-document-multiple</v-icon>
          <h1 class="header-title">{{ pageTitle }}</h1>
        </div>
        <div class="action-buttons">
          <v-btn icon class="action-btn refresh-btn" @click="refreshPageData" title="Refresh Data">
            <v-icon color="#3A67B1">mdi-refresh</v-icon>
          </v-btn>
          <v-btn icon class="action-btn close-btn" @click="closePrompt" title="Close">
            <v-icon color="#3A67B1">mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <v-card class="preview-card">
      <v-card-text>
        <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
          <b-spinner variant="primary" type="grow" label="Loading..."></b-spinner>
        </div>
        <v-container v-if="ResultFlag" class="preview-container">
          <!-- Sponsor Details Section -->
          <v-row wrap>
            <v-col cols="12" sm="12" lg="12" md="12">
              <div class="section-header">
                <v-icon class="section-icon" color="#0097D7">mdi-account-group</v-icon>
                <h3 class="section-title">Sponsor Details</h3>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="info-card sponsor-card">
                <div class="card-label">Sponsor Type</div>
                <div class="card-value">
                  <v-icon class="value-icon">mdi-domain</v-icon>
                  {{ row.SponsorTypeTxt }} <br />
                  <span class="location-text">{{ row.SponsorZoneName }} - {{ row.SponsorLomName }}</span>
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="info-card">
                <div class="card-label">Sponsor Member Name</div>
                <div class="card-value">
                  <v-icon class="value-icon">mdi-account</v-icon>
                  {{ row.SponsorMemberName }} <br />
                  <span class="id-text">{{
                    row.SponsorMemberMembershipId
                  }}</span>
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="info-card">
                <div class="card-label">Sponsor Mobile</div>
                <div class="card-value">
                  <v-icon class="value-icon">mdi-phone</v-icon>
                  {{ row.OrdersMobileNo }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="info-card">
                <div class="card-label">Sponsor Email</div>
                <div class="card-value">
                  <v-icon class="value-icon">mdi-email</v-icon>
                  {{ row.OrdersEmailId }}
                </div>
              </div>
            </v-col>
          </v-row>

          <!-- Payment Details Section -->
          <v-row wrap class="section-spacing">
            <v-col cols="12" sm="12" lg="12" md="12">
              <div class="section-header">
                <v-icon class="section-icon" color="#EDBE38">mdi-receipt</v-icon>
                <h3 class="section-title">LO Title Payment Details</h3>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="info-card">
                <div class="card-label">Paid Date</div>
                <div class="card-value">
                  <v-icon class="value-icon">mdi-calendar</v-icon>
                  {{ row.OrdersDate }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="info-card">
                <div class="card-label">Payment ID</div>
                <div class="card-value">
                  <v-icon class="value-icon">mdi-identifier</v-icon>
                  {{ row.PaymentId }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="info-card">
                <div class="card-label">Payment Method</div>
                <div class="card-value">
                  <v-icon class="value-icon">mdi-credit-card</v-icon>
                  {{ row.PaymentMethod }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="info-card amount-card">
                <div class="card-label">Paid Amount</div>
                <div class="card-value amount-value">
                  {{ row.TotalAmountTxt }}
                </div>
              </div>
            </v-col>
          </v-row>

          <!-- LO Title Details Section -->
          <v-row wrap class="section-spacing">
            <v-col cols="12" sm="12" lg="12" md="12">
              <div class="section-header">
                <v-icon class="section-icon" color="#56BDA3">mdi-briefcase</v-icon>
                <h3 class="section-title">LO Title Details</h3>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="info-card">
                <div class="card-label">LO Title Name</div>
                <div class="card-value">
                  <v-icon class="value-icon">mdi-text-box</v-icon>
                  {{ row.NewLomsName }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="info-card">
                <div class="card-label">State</div>
                <div class="card-value">
                  <v-icon class="value-icon">mdi-map</v-icon>
                  {{ row.NewLomStateName }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="info-card">
                <div class="card-label">District</div>
                <div class="card-value">
                  <v-icon class="value-icon">mdi-map-marker</v-icon>
                  {{ row.NewLomDistrictName }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="info-card">
                <div class="card-label">City</div>
                <div class="card-value">
                  <v-icon class="value-icon">mdi-city</v-icon>
                  {{ row.NewLomCityName }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3">
              <div class="info-card">
                <div class="card-label">Expiry Date</div>
                <div class="card-value">
                  <v-icon class="value-icon">mdi-clock-outline</v-icon>
                  {{ row.ExpiryDateTxt }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3" v-if="!previewFlag && row.PaymentApprovalFlag">
              <div class="info-card lady-lo-card">
                <div class="card-label">LO Type</div>
                <v-radio-group v-model="row.IsLadyLo" color="#FF69B4" class="lady-radio">
                  <v-radio :value="1" label="Lady LO"></v-radio>
                  <v-radio :value="0" label="Regular LO"></v-radio>
                </v-radio-group>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="3" v-if="!previewFlag">
              <div class="info-card">
                <div class="card-label">Expiry Date</div>
                <v-menu v-model="menu_expiry" :close-on-content-click="false" :nudge-right="40"
                  transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="row.ExpiryDateTxt" readonly prepend-icon="mdi-calendar" v-bind="attrs"
                      v-on="on" class="date-input"></v-text-field>
                  </template>
                  <v-date-picker v-model="row.ExpiryDate" @input="onExpiryDateSelect" color="#3A67B1"></v-date-picker>
                </v-menu>
              </div>
            </v-col>
            <!-- Documents Reupload Section -->
            <v-col cols="12" sm="12" lg="12" md="12" v-if="
              !previewFlag &&
              (row.TitleApprovalStatus != 1 ||
                row.PresidentApprovalStatus != 1)
            ">
              <div class="reupload-section-header">
                <v-icon class="section-icon" color="#FF6B6B">mdi-file-upload-outline</v-icon>
                <h3 class="section-title">Document Management</h3>
                <span class="section-subtitle">Update required documents</span>
              </div>
            </v-col>

            <!-- LGB Resolution Document -->
            <v-col cols="12" sm="12" lg="6" md="6" v-if="
              row.LGBResolutionFilePath != '' && (previewFlag || row.TitleApprovalStatus != 1)
            ">
              <div class="document-card">
                <div class="document-header">
                  <div class="document-info">
                    <v-icon class="document-icon lgb-icon">mdi-file-pdf-box</v-icon>
                    <div class="document-text">
                      <h4 class="document-title">LGB Resolution</h4>
                      <p class="document-subtitle">PDF Document</p>
                    </div>
                  </div>
                  <v-btn :href="row.LGBResolutionFilePath" target="_blank" icon small class="view-btn"
                    title="View current document" color="#FF6B6B">
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </div>

                <div class="document-divider" v-if="!previewFlag"></div>

                <div v-if="!previewFlag" class="upload-zone" @dragover.prevent="onDragOver($event, 1)"
                  @dragleave.prevent="onDragLeave($event, 1)" @drop.prevent="onDrop($event, 1)"
                  :class="{ 'drag-active': dragActive === 1 }">
                  <input type="file" ref="fileInput1" accept="application/pdf" @change="handleFileSelect($event, 1)"
                    class="file-input-hidden" />
                  <div class="upload-content" @click="$refs.fileInput1.click()">
                    <v-icon class="upload-icon">mdi-cloud-upload-outline</v-icon>
                    <h5 class="upload-title">Drag & Drop Your PDF</h5>
                    <p class="upload-subtitle">or click to browse</p>
                    <p class="upload-hint">Max file size: 10 MB</p>
                  </div>
                  <div class="file-preview" v-if="LGBResolutionFile && LGBResolutionFile.name">
                    <v-icon class="preview-icon success">mdi-check-circle</v-icon>
                    <span class="preview-name">{{
                      LGBResolutionFile.name
                    }}</span>
                    <span class="preview-size">{{
                      formatFileSize(LGBResolutionFile.size)
                    }}</span>
                    <v-icon class="remove-icon" @click.stop="clearFile('LGB')">mdi-close-circle</v-icon>
                  </div>
                </div>
              </div>
            </v-col>

            <!-- Orientation Certificate Document -->
            <v-col cols="12" sm="12" lg="6" md="6" v-if="
              row.OrientationCertificateFilePath != '' &&
              (previewFlag || row.PresidentApprovalStatus != 1)
            ">
              <div class="document-card" @dragover.prevent="onDragOver($event, 2)" @drop.prevent="onDrop($event, 2)">
                <div class="document-header">
                  <div class="document-info">
                    <v-icon class="document-icon cert-icon">mdi-certificate</v-icon>
                    <div class="document-text">
                      <h4 class="document-title">Orientation Certificate</h4>
                      <p class="document-subtitle">PDF Document</p>
                    </div>
                  </div>
                  <v-btn :href="row.OrientationCertificateFilePath" target="_blank" icon small class="view-btn"
                    title="View current document" color="#4ECDC4">
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </div>

                <div class="document-divider" v-if="!previewFlag"></div>

                <div v-if="!previewFlag" class="upload-zone" @dragover.prevent="onDragOver($event, 2)"
                  @dragleave.prevent="onDragLeave($event, 2)" @drop.prevent="onDrop($event, 2)"
                  :class="{ 'drag-active': dragActive === 2 }">
                  <input type="file" ref="fileInput2" accept="application/pdf" @change="handleFileSelect($event, 2)"
                    class="file-input-hidden" />
                  <div class="upload-content" @click="$refs.fileInput2.click()">
                    <v-icon class="upload-icon">mdi-cloud-upload-outline</v-icon>
                    <h5 class="upload-title">Drag & Drop Your PDF</h5>
                    <p class="upload-subtitle">or click to browse</p>
                    <p class="upload-hint">Max file size: 10 MB</p>
                  </div>
                  <div class="file-preview" v-if="
                    OrientationCertificateFile &&
                    OrientationCertificateFile.name
                  ">
                    <v-icon class="preview-icon success">mdi-check-circle</v-icon>
                    <span class="preview-name">{{
                      OrientationCertificateFile.name
                    }}</span>
                    <span class="preview-size">{{
                      formatFileSize(OrientationCertificateFile.size)
                    }}</span>
                    <v-icon class="remove-icon" @click.stop="clearFile('Certificate')">mdi-close-circle</v-icon>
                  </div>
                </div>
              </div>
            </v-col>

            <!-- Membership List Document -->
            <v-col cols="12" sm="12" lg="6" md="6" v-if="
              row.MembershipListFilePath != '' &&
              (previewFlag || row.PresidentApprovalStatus != 1)
            ">
              <div class="document-card" @dragover.prevent="onDragOver($event, 3)" @drop.prevent="onDrop($event, 3)">
                <div class="document-header">
                  <div class="document-info">
                    <v-icon class="document-icon list-icon">mdi-file-document</v-icon>
                    <div class="document-text">
                      <h4 class="document-title">Membership List</h4>
                      <p class="document-subtitle">PDF Document</p>
                    </div>
                  </div>
                  <v-btn :href="row.MembershipListFilePath" target="_blank" icon small class="view-btn"
                    title="View current document" color="#95E1D3">
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </div>

                <div class="document-divider" v-if="!previewFlag"></div>

                <div v-if="!previewFlag" class="upload-zone" @dragover.prevent="onDragOver($event, 3)"
                  @dragleave.prevent="onDragLeave($event, 3)" @drop.prevent="onDrop($event, 3)"
                  :class="{ 'drag-active': dragActive === 3 }">
                  <input type="file" ref="fileInput3" accept="application/pdf" @change="handleFileSelect($event, 3)"
                    class="file-input-hidden" />
                  <div class="upload-content" @click="$refs.fileInput3.click()">
                    <v-icon class="upload-icon">mdi-cloud-upload-outline</v-icon>
                    <h5 class="upload-title">Drag & Drop Your PDF</h5>
                    <p class="upload-subtitle">or click to browse</p>
                    <p class="upload-hint">Max file size: 10 MB</p>
                  </div>
                  <div class="file-preview" v-if="MembershipListFile && MembershipListFile.name">
                    <v-icon class="preview-icon success">mdi-check-circle</v-icon>
                    <span class="preview-name">{{
                      MembershipListFile.name
                    }}</span>
                    <span class="preview-size">{{
                      formatFileSize(MembershipListFile.size)
                    }}</span>
                    <v-icon class="remove-icon" @click.stop="clearFile('List')">mdi-close-circle</v-icon>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" v-if="row.TitleApprovalDescription != ''">
              <div class="description-card">
                <div class="card-label">Description</div>
                <div class="card-value" v-html="row.TitleApprovalDescription"></div>
              </div>
            </v-col>
          </v-row>
          <!-- Subscription Section -->
          <v-container v-if="row.SubscriptionPaymentFlag" class="subscription-section">
            <!-- New President Details -->
            <v-row wrap class="section-spacing">
              <v-col cols="12" sm="12" lg="12" md="12">
                <div class="section-header">
                  <v-icon class="section-icon" color="#3A67B1">mdi-account-tie</v-icon>
                  <h3 class="section-title">New President Details</h3>
                </div>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="info-card">
                  <div class="card-label">President Type</div>
                  <div class="card-value">
                    <v-icon class="value-icon">mdi-account</v-icon>
                    {{ row.PresidentsMemberTypeTxt }}
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="info-card">
                  <div class="card-label">President Name</div>
                  <div class="card-value">
                    <v-icon class="value-icon">mdi-account</v-icon>
                    {{ row.PresidentsFirstName }} <br />
                    <span class="id-text">{{
                      row.PresidentsMembershipId
                    }}</span>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="info-card">
                  <div class="card-label">President Mobile</div>
                  <div class="card-value">
                    <v-icon class="value-icon">mdi-phone</v-icon>
                    {{ row.PresidentsMobileNo }}
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="info-card">
                  <div class="card-label">President Email</div>
                  <div class="card-value">
                    <v-icon class="value-icon">mdi-email</v-icon>
                    {{ row.PresidentsEmailId }}
                  </div>
                </div>
              </v-col>
            </v-row>

            <!-- New Secretary Details -->
            <v-row wrap class="section-spacing" v-if="row.SecretaryJmPresidentsId">
              <v-col cols="12" sm="12" lg="12" md="12">
                <div class="section-header">
                  <v-icon class="section-icon" color="#0097D7">mdi-clipboard</v-icon>
                  <h3 class="section-title">New Secretary Details</h3>
                </div>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="info-card">
                  <div class="card-label">Secretary Type</div>
                  <div class="card-value">
                    <v-icon class="value-icon">mdi-badge-account</v-icon>
                    {{ row.SecretaryMemberTypeTxt }}
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="info-card">
                  <div class="card-label">Secretary Name</div>
                  <div class="card-value">
                    <v-icon class="value-icon">mdi-account</v-icon>
                    {{ row.SecretaryFirstName }} <br />
                    <span class="id-text">{{ row.SecretaryMembershipId }}</span>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="info-card">
                  <div class="card-label">Secretary Mobile</div>
                  <div class="card-value">
                    <v-icon class="value-icon">mdi-phone</v-icon>
                    {{ row.SecretaryMobileNo }}
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="info-card">
                  <div class="card-label">Secretary Email</div>
                  <div class="card-value">
                    <v-icon class="value-icon">mdi-email</v-icon>
                    {{ row.SecretaryEmailId }}
                  </div>
                </div>
              </v-col>
            </v-row>

            <!-- Subscription Payment Details -->
            <v-row wrap class="section-spacing">
              <v-col cols="12" sm="12" lg="12" md="12">
                <div class="section-header">
                  <v-icon class="section-icon" color="#EDBE38">mdi-cash-multiple</v-icon>
                  <h3 class="section-title">Subscription Payment Details</h3>
                </div>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="info-card">
                  <div class="card-label">Paid Date</div>
                  <div class="card-value">
                    <v-icon class="value-icon">mdi-calendar</v-icon>
                    {{ row.SubscriptionOrdersDateTxt }}
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="info-card">
                  <div class="card-label">Payment ID</div>
                  <div class="card-value">
                    <v-icon class="value-icon">mdi-identifier</v-icon>
                    {{ row.SubscriptionPaymentId }}
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="info-card">
                  <div class="card-label">Payment Method</div>
                  <div class="card-value">
                    <v-icon class="value-icon">mdi-credit-card</v-icon>
                    {{ row.SubscriptionPaymentMethod }}
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="info-card amount-card">
                  <div class="card-label">Paid Amount</div>
                  <div class="card-value amount-value">
                    {{ row.SubscriptionTotalAmountTxt }}
                  </div>
                </div>
              </v-col>
              <v-col cols="12" v-if="row.Description != ''">
                <div class="description-card">
                  <div class="card-label">Description</div>
                  <div class="card-value" v-html="row.Description"></div>
                </div>
              </v-col>
            </v-row>

            <!-- Subscription Items Table -->
            <v-row wrap class="section-spacing">
              <v-col cols="12" sm="12" lg="12" md="12">
                <div class="section-header">
                  <v-icon class="section-icon" color="#56BDA3">mdi-table</v-icon>
                  <h3 class="section-title">Subscription Items</h3>
                </div>
              </v-col>
              <v-col cols="12" sm="12" lg="12" md="12">
                <div class="table-wrapper">
                  <v-data-table class="professional-table" loading-text="Loading... Please wait" disable-sort
                    disable-filtering :item-key="tableOptions1.ItemKey" :headers="tableColumns1" :items="tableData1"
                    hide-default-footer>
                    <template v-slot:body="{ items }">
                      <tbody>
                        <tr v-for="(item, index) in items" :key="index" class="table-row"
                          :class="{ 'even-row': index % 2 === 0 }">
                          <td v-for="header in tableColumns1" :key="header.value" class="table-cell">
                            {{ item[header.value] }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-data-table>
                </div>
              </v-col>
            </v-row>
          </v-container>
          <!-- Approval Section -->
          <div v-if="!previewFlag">
            <v-container v-if="
              row.TitleApprovalFlag ||
              row.TitleConfirmationFlag ||
              row.PaymentApprovalFlag
            " class="approval-section">
              <!-- Header Section -->
              <v-row wrap>
                <v-col cols="12" sm="12" lg="12" md="12">
                  <div class="approval-header">
                    <v-icon large class="header-icon">mdi-clipboard-check-outline</v-icon>
                    <div class="header-content">
                      <h3 class="header-title">Administrative Review</h3>
                      <p class="header-subtitle" v-if="
                        row.TitleApprovalFlag || row.TitleConfirmationFlag
                      ">
                        New LO Title Administrative Processing
                      </p>
                      <p class="header-subtitle" v-if="row.PaymentApprovalFlag">
                        New LO Subscription Payment Processing
                      </p>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <!-- Form Section -->
              <v-form ref="form1" v-model="valid1" lazy-validation v-on:submit.prevent="searchForm">
                <!-- Title Approval Section -->
                <v-row wrap v-if="row.TitleApprovalFlag" class="form-section">
                  <v-col cols="12" sm="12" lg="6" md="6">
                    <div class="form-field-wrapper">
                      <label class="form-label">
                        <span class="required-indicator">*</span> New LO Title
                        Name
                      </label>
                      <v-text-field v-model="NewLoName" :rules="NewLoNameRules" hint="Enter the New LO Title Name"
                        outlined dense prepend-inner-icon="mdi-text-box" class="premium-textfield"
                        background-color="#FAFBFC"></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="12" lg="6" md="6">
                    <div class="form-field-wrapper">
                      <label class="form-label">
                        <span class="required-indicator">*</span> Approval
                        Description
                      </label>
                      <v-textarea v-model="ApprovalDescription" :rules="ApprovalDescriptionRules"
                        hint="Provide detailed approval notes" outlined dense rows="3" prepend-inner-icon="mdi-pencil"
                        class="premium-textfield" background-color="#FAFBFC"></v-textarea>
                    </div>
                  </v-col>
                </v-row>

                <!-- Title Confirmation Section -->
                <v-row wrap v-if="row.TitleConfirmationFlag" class="form-section">
                  <v-col cols="12" sm="12" lg="12" md="12">
                    <div class="form-field-wrapper">
                      <label class="form-label">
                        <span class="required-indicator">*</span> Confirmation
                        Description
                      </label>
                      <v-textarea v-model="ApprovalDescription" :rules="ApprovalDescriptionRules"
                        hint="Provide confirmation notes and remarks" outlined dense rows="4"
                        prepend-inner-icon="mdi-clipboard-text" class="premium-textfield"
                        background-color="#FAFBFC"></v-textarea>
                    </div>
                  </v-col>
                </v-row>

                <!-- Payment Approval Section -->
                <v-row wrap v-if="row.PaymentApprovalFlag" class="form-section">
                  <v-col cols="12" sm="12" lg="5" md="5">
                    <div class="form-field-wrapper">
                      <label class="form-label">
                        <span class="required-indicator">*</span> Provisional
                        Date
                      </label>
                      <div class="date-info-box">
                        <v-icon small class="info-icon">mdi-information-outline</v-icon>
                        <p class="info-text">
                          Affiliation date will be auto-calculated based on this
                          date
                        </p>
                      </div>
                      <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" lazy
                        transition="scale-transition" offset-y full-width min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-text-field required v-model="ProvisionalDate" label="Select Date" readonly v-on="on"
                            outlined dense prepend-inner-icon="mdi-calendar-range" class="premium-textfield"
                            background-color="#FAFBFC"></v-text-field>
                        </template>
                        <v-date-picker v-model="ProvisionalDate" @input="menu1 = false" color="#8950FC"></v-date-picker>
                      </v-menu>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="12" lg="7" md="7">
                    <div class="form-field-wrapper">
                      <label class="form-label">
                        <span class="required-indicator">*</span> Approval
                        Description
                      </label>
                      <v-textarea v-model="ApprovalDescription" :rules="ApprovalDescriptionRules"
                        hint="Enter approval notes and payment details" outlined dense rows="3"
                        prepend-inner-icon="mdi-note-text" class="premium-textfield"
                        background-color="#FAFBFC"></v-textarea>
                    </div>
                  </v-col>
                </v-row>

                <!-- Action Buttons Section -->
                <v-row wrap class="action-section">
                  <v-col cols="12" sm="12" lg="12" md="12">
                    <div class="button-group">
                      <v-btn v-if="row.TitleConfirmationFlag" @click.prevent="confirmAlert(1)"
                        :loading="ApproveLoadingFlag" color="#10B981" elevation="0" rounded x-large
                        class="action-btn approve-btn" min-width="180">
                        <v-icon left>mdi-check-circle</v-icon>
                        Confirm
                      </v-btn>
                      <v-btn v-else @click.prevent="confirmAlert(1)" :loading="ApproveLoadingFlag" color="#10B981"
                        elevation="0" rounded x-large class="action-btn approve-btn" min-width="180">
                        <v-icon left>mdi-check-circle</v-icon>
                        Approve
                      </v-btn>
                      <v-btn @click.prevent="confirmAlert(2)" :loading="ApproveRejectLoadingFlag" color="#EF4444"
                        elevation="0" rounded x-large class="action-btn reject-btn" min-width="180">
                        <v-icon left>mdi-close-circle</v-icon>
                        Reject
                      </v-btn>
                      <v-btn @click="closePrompt" color="#6B7280" elevation="0" rounded x-large outlined
                        class="action-btn cancel-btn" min-width="180">
                        <v-icon left>mdi-cancel</v-icon>
                        Cancel
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </div>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    previewFlag: {
      type: Boolean,
      required: true,
    },
    recordData: {
      required: true,
    },
    pageTitle: {
      type: String,
    },
  },
  data() {
    return {
      valid1: false,
      valid2: false,
      ProgressLoadingFlag: false,
      ResultFlag: false,
      LoadingFlag: false,
      row: {},
      PaymentDetails: {},
      selected: [],

      NewLoName: "",
      NewLoNameRules: [(v) => !!v || "Description is required"],
      ApprovalDescription: "",
      ApprovalDescriptionRules: [(v) => !!v || "Description is required"],

      ConfirmationDescription: "",
      ConfirmationDescriptionRules: [(v) => !!v || "Description is required"],

      ApproveLoadingFlag: false,
      ApproveRejectLoadingFlag: false,
      ConfirmationLoadingFlag: false,
      ConfirmationRejectLoadingFlag: false,

      ZoneCode: "",
      LomCode: "",

      tableColumns1: [],
      tableOptions1: {},
      tableData1: [],

      ProvisionalDate: new Date().toISOString().slice(0, 10),
      menu1: false,
      menu_expiry: false,
      LGBResolutionFile: {},
      OrientationCertificateFile: {},
      MembershipListFile: {},
      dragActive: null,
      UploadLoadingFlag: null,
    };
  },
  computed: {},
  watch: {
    NewLoName: function () {
      console.log("NewLoName watch");
      this.NewLoName = this.NewLoName.toUpperCase();
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    clearFile(fileType) {
      if (fileType === "LGB") {
        this.LGBResolutionFile = {};
      } else if (fileType === "Certificate") {
        this.OrientationCertificateFile = {};
      } else if (fileType === "List") {
        this.MembershipListFile = {};
      }
    },
    formatFileSize(bytes) {
      if (!bytes) return "0 B";
      const k = 1024;
      const sizes = ["B", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
    },
    onDragOver(event, docType) {
      event.preventDefault();
      event.stopPropagation();
      this.dragActive = docType;
    },
    onDragLeave(event, docType) {
      event.preventDefault();
      event.stopPropagation();
      if (this.dragActive === docType) {
        this.dragActive = null;
      }
    },
    onDrop(event, docType) {
      event.preventDefault();
      event.stopPropagation();
      this.dragActive = null;

      const files = event.dataTransfer.files;
      if (files && files.length > 0) {
        const file = files[0];

        // Validate file type
        if (file.type !== "application/pdf") {
          this.toast("error", "Only PDF files are allowed");
          return;
        }

        // Validate file size (10 MB max)
        if (file.size > 10 * 1024 * 1024) {
          this.toast("error", "File size must be less than 10 MB");
          return;
        }

        // Set the file based on docType
        if (docType === 1) {
          this.LGBResolutionFile = file;
        } else if (docType === 2) {
          this.OrientationCertificateFile = file;
        } else if (docType === 3) {
          this.MembershipListFile = file;
        }
      }
    },
    handleFileSelect(event, docType) {
      const files = event.target.files;
      if (files.length === 0) return;

      const file = files[0];

      // Validate file type
      if (file.type !== "application/pdf") {
        this.toast("error", "Only PDF files are allowed");
        return;
      }

      // Validate file size (10 MB max)
      if (file.size > 10 * 1024 * 1024) {
        this.toast("error", "File size must be less than 10 MB");
        return;
      }

      // Set the file based on docType
      if (docType === 1) {
        this.LGBResolutionFile = file;
      } else if (docType === 2) {
        this.OrientationCertificateFile = file;
      } else if (docType === 3) {
        this.MembershipListFile = file;
      }

      // Auto-upload after file selection
      this.$nextTick(() => {
        this.uploadDocument(docType);
      });
    },
    uploadDocument(docType) {
      console.log("uploadDocument called with docType=" + docType);
      var fileData = null;
      var fileType = "";
      if (docType === 1) {
        fileData = this.LGBResolutionFile;
        fileType = "LGBResolution";
      } else if (docType === 2) {
        fileData = this.OrientationCertificateFile;
        fileType = "OrientationCertificate";
      } else if (docType === 3) {
        fileData = this.MembershipListFile;
        fileType = "MembershipList";
      }

      if (!fileData || !fileData.name) {
        this.toast("error", "Please select a valid file.");
        return;
      }

      var tr = this.recordData;
      var OrderId = tr.JmOrdersId;
      var NewLomsId = tr.JmNewLomsId;

      this.LoadingFlag = true;
      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/new-lom/document-reupload";

      let uploadParams = new FormData();
      uploadParams.append("UserInterface", 1);
      uploadParams.append("Order", OrderId);
      uploadParams.append("NewLom", NewLomsId);
      uploadParams.append("DocType", docType);
      uploadParams.append("UploadFile", fileData);

      const thisIns = this;
      this.UploadLoadingFlag = docType;
      this.$http({
        url: add_url,
        method: "POST",
        data: uploadParams,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          thisIns.LoadingFlag = false;
          thisIns.UploadLoadingFlag = null;
          var flag = response.data.flag;
          var output = response.data.output;
          if (flag == 1) {
            thisIns.toast("success", output);

            // Get newly returned asset path
            var newFilePath =
              response.data.records && response.data.records.FilePath
                ? response.data.records.FilePath
                : "";
            var timestamp = new Date().getTime();
            if (newFilePath != "") {
              newFilePath += "?t=" + timestamp;
            }

            // Reset file objects & apply reactive update directly without full reload
            if (docType === 1) {
              thisIns.LGBResolutionFile = {};
              if (newFilePath != "")
                thisIns.row.LGBResolutionFilePath = newFilePath;
            } else if (docType === 2) {
              thisIns.OrientationCertificateFile = {};
              if (newFilePath != "")
                thisIns.row.OrientationCertificateFilePath = newFilePath;
            } else if (docType === 3) {
              thisIns.MembershipListFile = {};
              if (newFilePath != "")
                thisIns.row.MembershipListFilePath = newFilePath;
            }
          } else {
            thisIns.sweetAlert("error", output, false);
          }
        })
        .catch(function (error) {
          thisIns.LoadingFlag = false;
          thisIns.UploadLoadingFlag = null;
          thisIns.toast("error", error);
        });
    },
    closePrompt() {
      console.log("closePrompt called");
      var previewFlag = this.previewFlag;
      if (previewFlag) {
        this.$emit("hidePreviewRecordPrompt");
      } else {
        this.$emit("hideEditRecordPrompt");
      }
    },
    refreshPageData() {
      console.log("refreshPageData called");
      var recordData = this.recordData;
      console.log("recordData=" + JSON.stringify(recordData));
      this.getTableRecords();
    },
    getTableRecords() {
      console.log("getTableRecords called");

      var message = "";

      var previewFlag = this.previewFlag;
      console.log({ previewFlag });

      var UserInterface = previewFlag ? 1 : 2;
      console.log({ UserInterface });

      var tr = this.recordData;
      console.log({ tr });

      var OrderId = tr.JmOrdersId;
      var NewLomsId = tr.JmNewLomsId;

      if (OrderId != "" && NewLomsId != "") {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/new-lom/show";
        var upload = {
          UserInterface: UserInterface,
          Order: OrderId,
          NewLom: NewLomsId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
          server_url +
          ", token=" +
          token +
          ", add_url=" +
          add_url
        );

        this.row = {};
        this.ResultFlag = false;

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.LoadingFlag = true;
        this.Documentpath = "";

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;

            flag = response.data.flag;
            console.log({ flag });

            output = response.data.output;
            console.log({ output });

            records = response.data.records;
            console.log({ records });

            thisIns.ResultFlag = flag;

            var Subscribtions = records.Subscribtions;
            console.log({ Subscribtions });

            if (flag == 1) {
              var timestamp = new Date().getTime();
              if (
                records.LGBResolutionFilePath &&
                records.LGBResolutionFilePath != ""
              ) {
                records.LGBResolutionFilePath += "?t=" + timestamp;
              }
              if (
                records.OrientationCertificateFilePath &&
                records.OrientationCertificateFilePath != ""
              ) {
                records.OrientationCertificateFilePath += "?t=" + timestamp;
              }
              if (
                records.MembershipListFilePath &&
                records.MembershipListFilePath != ""
              ) {
                records.MembershipListFilePath += "?t=" + timestamp;
              }
              thisIns.row = records;
              thisIns.NewLoName = records.NewLomsName;
              // Format ExpiryDateTxt to YYYY-MM-DD if it exists
              if (records.ExpiryDateTxt) {
                thisIns.row.ExpiryDateTxt = thisIns.formatDateToISO(
                  records.ExpiryDateTxt
                );
              }
              thisIns.tableColumns1 = Subscribtions.TableHeader;
              thisIns.tableData1 = Subscribtions.TableData;
              thisIns.tableOptions1 = Subscribtions.TableOptions;
              // thisIns.toast("success", output);
            } else {
              // thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            // thisIns.toast("error", error);
            thisIns.LoadingFlag = false;
          });
      } else {
        if (OrderId == "") {
          message += "Order details are invalid. ";
        }
        if (NewLomsId == "") {
          message += "New LOM details are invalid. ";
        }
        this.toast("error", message);
      }
    },
    onExpiryDateSelect(val) {
      // Sync date-picker value to display text (format: YYYY-MM-DD)
      try {
        this.row.ExpiryDate = val;
        if (!val) {
          this.row.ExpiryDateTxt = "";
          this.menu_expiry = false;
          return;
        }
        const d = new Date(val);
        if (isNaN(d.getTime())) {
          // fallback: use raw value
          this.row.ExpiryDateTxt = val;
        } else {
          // Format as YYYY-MM-DD (e.g., "2022-06-19")
          const year = d.getFullYear();
          const month = String(d.getMonth() + 1).padStart(2, "0");
          const day = String(d.getDate()).padStart(2, "0");
          this.row.ExpiryDateTxt = `${year}-${month}-${day}`;
        }
        this.menu_expiry = false;
      } catch (err) {
        console.error("onExpiryDateSelect error", err);
      }
    },
    formatDateToISO(dateStr) {
      // Convert any date format (e.g., "29-Mar-2026", "2022-06-19") to YYYY-MM-DD
      try {
        if (!dateStr) return "";
        const d = new Date(dateStr);
        if (isNaN(d.getTime())) {
          return dateStr; // return as-is if parsing fails
        }
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      } catch (err) {
        console.error("formatDateToISO error", err);
        return dateStr;
      }
    },
    confirmAlert(status) {
      console.log("confirmAlert is called");
      console.log({ status });
      var htmlTxt = "";

      var validate = this.$refs.form1.validate();
      console.log({ validate });

      if (validate) {
        Swal.fire({
          title: "Do you want to continue?",
          text: "Please verify all the information before proceeding.",
          icon: "warning",
          html: htmlTxt,
          showCancelButton: true,
          confirmButtonText: `Continue`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            switch (status) {
              case 1:
                this.approvalSubmitForm(1);

                break;

              case 2:
                this.approvalSubmitForm(2);

                break;

              default:
                break;
            }
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      }
    },
    approvalSubmitForm(status) {
      console.log("approvalSubmitForm is called");

      console.log({ status });

      var tr = this.row;
      console.log({ tr });

      this.ProgressLoadingFlag = true;

      var OrderId = tr.JmOrdersId;
      console.log({ OrderId });

      var NewLomsId = tr.JmNewLomsId;
      console.log({ NewLomsId });

      var NewPresidentsId = tr.JmPresidentsId;
      console.log({ NewPresidentsId });

      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;

      var OrdersType = tr.OrdersType;
      console.log({ OrdersType });

      var server_url = companyConfig.apiURL;
      var add_url1 = server_url + "api/new-lom-title/approval-status-update";
      var add_url2 = server_url + "api/new-lom-payment/approval-status-update";

      var add_url = OrdersType == 3 ? add_url1 : add_url2;
      console.log({ add_url });

      var UserInterface = OrdersType == 4 ? 1 : tr.TitleApprovalFlag ? 1 : 2;
      console.log({ UserInterface });

      var upload = {
        UserInterface: UserInterface,
        NewLoName: this.NewLoName,
        Order: OrderId,
        NewLom: NewLomsId,
        NewPresident: NewPresidentsId,
        Description: this.ApprovalDescription,
        ProvisionalDate: this.ProvisionalDate,
        Status: status,
        IsLadyLo: this.row.IsLadyLo,
        ExpiryDate: this.row.ExpiryDateTxt,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var records = {};
      var table = {};
      var successTxt = "";
      var errorTxt = "";
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.ProgressLoadingFlag = false;
          output = response.data.output;
          flag = response.data.flag;
          output = response.data.output;
          records = response.data.records;
          console.log("output=" + output + ", flag=" + flag);
          successTxt = response.data.success;
          errorTxt = response.data.error;
          console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

          if (flag == 1) {
            thisIns.sweetAlert("success", output, true);
            thisIns.$emit("hideEditRecordPrompt");
          } else {
            thisIns.sweetAlert("error", output, false);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.SearchFlag = false;
          thisIns.ProgressLoadingFlag = true;
        });
    },
  },
  beforeMount() {
    var ZoneCode = this.$session.get("ZoneId");
    ZoneCode = ZoneCode == (null || undefined) ? "" : ZoneCode;
    console.log({ ZoneCode });
    this.ZoneCode = ZoneCode;

    var LomCode = this.$session.get("LomId");
    LomCode = LomCode == (null || undefined) ? "" : LomCode;
    console.log({ LomCode });
    this.LomCode = LomCode;

    this.refreshPageData();
  },
  beforeDestroy() {

  },
};
</script>
<style lang="scss">
/* JCI Approved Colors */
$navy: #3a67b1;
$aqua: #0097d7;
$gold: #edbe38;
$seaform: #56bda3;
$text-dark: #414042;
$text-black: #0a0f29;
$white: #ffffff;

#events-preview {

  /* Premium Header Styling */
  .premium-header {
    background: linear-gradient(135deg, $navy 0%, $aqua 100%);
    padding: 24px;
    box-shadow: 0 4px 20px rgba($navy, 0.15);
    display: flex;
    align-items: center;
    animation: slideDown 0.5s ease-out;

    .header-content {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .title-section {
      display: flex;
      align-items: center;
      gap: 16px;

      .title-icon {
        font-size: 32px !important;
        animation: bounceIn 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55);
      }

      .header-title {
        color: $white;
        font-size: 28px;
        font-weight: 700;
        margin: 0;
        letter-spacing: 0.5px;
      }
    }

    .action-buttons {
      display: flex;
      gap: 12px;

      .action-btn {
        background: rgba($white, 0.2) !important;
        backdrop-filter: blur(10px);
        border-radius: 50%;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        width: 48px !important;
        height: 48px !important;

        &:hover {
          background: rgba($white, 0.3) !important;
          transform: scale(1.1) rotate(5deg);
          box-shadow: 0 8px 24px rgba($navy, 0.3);
        }

        &:active {
          transform: scale(0.95);
        }
      }
    }
  }

  /* Preview Card */
  .preview-card {
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba($navy, 0.1);
    animation: fadeInUp 0.6s ease-out;
  }

  .preview-container {
    padding: 24px;
  }

  /* Section Header Styling */
  .section-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 3px solid transparent;
    animation: slideIn 0.5s ease-out;

    .section-icon {
      font-size: 28px !important;
    }

    .section-title {
      color: $text-black;
      font-size: 20px;
      font-weight: 700;
      margin: 0;
      letter-spacing: 0.3px;
    }
  }

  /* Section Spacing */
  .section-spacing {
    margin-top: 40px;
    margin-bottom: 40px;
    padding-top: 16px;
    border-top: 1px solid rgba($navy, 0.1);
  }

  /* Info Cards */
  .info-card {
    background: linear-gradient(135deg,
        rgba($white, 0.95) 0%,
        rgba($white, 0.98) 100%);
    border: 1px solid rgba($navy, 0.1);
    border-radius: 12px;
    padding: 18px;
    height: 100%;
    display: flex;
    flex-direction: column;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    animation: cardFadeIn 0.6s ease-out both;

    &:hover {
      transform: translateY(-6px);
      box-shadow: 0 12px 24px rgba($navy, 0.15);
      border-color: rgba($navy, 0.3);

      .card-label {
        color: $navy;
      }
    }

    .card-label {
      font-size: 12px;
      font-weight: 600;
      color: $text-dark;
      text-transform: uppercase;
      letter-spacing: 0.8px;
      margin-bottom: 8px;
      transition: color 0.3s ease;
    }

    .card-value {
      color: $text-black;
      font-size: 14px;
      line-height: 1.6;
      display: flex;
      align-items: flex-start;
      gap: 8px;
      flex: 1;

      .value-icon {
        color: $aqua;
        flex-shrink: 0;
        margin-top: 2px;
      }

      .location-text,
      .id-text {
        display: block;
        font-size: 12px;
        color: $text-dark;
        margin-top: 4px;
      }
    }
  }

  /* Sponsor Card */
  .sponsor-card {
    border-left: 4px solid $aqua;

    &:hover {
      border-left-color: $navy;
    }
  }

  /* Amount Card */
  .amount-card {
    background: linear-gradient(135deg,
        rgba($gold, 0.1) 0%,
        rgba($gold, 0.05) 100%);
    border: 2px solid rgba($gold, 0.3);

    .amount-value {
      color: $gold;
      font-size: 18px;
      font-weight: 700;
    }
  }

  /* Lady LO Card */
  .lady-lo-card {
    border-left: 4px solid #ff69b4;

    &:hover {
      border-left-color: #ff1493;
    }

    .lady-radio {
      margin-top: 8px;

      ::v-deep .v-radio {
        margin-right: 12px;

        .v-radio__label {
          font-size: 13px;
          font-weight: 500;
        }
      }
    }
  }

  /* Date Input */
  .date-input {
    ::v-deep {
      .v-input__prepend-inner {
        margin-right: 8px;
      }

      .v-input__control {
        .v-input__slot {
          input {
            font-size: 13px;
            cursor: pointer;
          }
        }
      }
    }
  }

  .lady-lo-card {
    border-left: 4px solid #ff69b4;

    .lady-switch {
      margin-top: 8px;

      ::v-deep .v-input__control {
        .v-input__slot {
          margin: 0;
        }
      }
    }
  }

  /* Description Card */
  .description-card {
    background: linear-gradient(135deg,
        rgba($seaform, 0.05) 0%,
        rgba($aqua, 0.05) 100%);
    border: 1px solid rgba($seaform, 0.2);
    border-radius: 12px;
    padding: 18px;
    animation: cardFadeIn 0.6s ease-out;

    .card-label {
      font-size: 12px;
      font-weight: 600;
      color: $text-dark;
      text-transform: uppercase;
      letter-spacing: 0.8px;
      margin-bottom: 12px;
    }

    .card-value {
      color: $text-black;
      font-size: 14px;
      line-height: 1.8;
    }
  }

  /* File Buttons */
  .file-btn {
    background: linear-gradient(135deg, $navy 0%, $aqua 100%) !important;
    color: $white !important;
    border-radius: 8px;
    padding: 10px 16px !important;
    font-weight: 600;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 12px rgba($navy, 0.25);
    width: 100%;
    text-transform: uppercase;
    font-size: 12px;
    letter-spacing: 0.5px;

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 8px 20px rgba($navy, 0.35);

      ::v-deep .v-icon {
        animation: spin 0.6s ease-in-out;
      }
    }

    &:active {
      transform: translateY(-1px);
    }

    span {
      display: inline-block;
    }
  }

  /* Reupload Section Styles */
  .reupload-section-header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 24px;
    padding: 20px;
    background: linear-gradient(135deg,
        rgba(#ff6b6b, 0.1) 0%,
        rgba(#ff8787, 0.05) 100%);
    border-radius: 12px;
    border-left: 5px solid #ff6b6b;
    animation: slideIn 0.5s ease-out;

    .section-icon {
      font-size: 32px !important;
      flex-shrink: 0;
    }

    .section-title {
      color: $text-black;
      font-size: 22px;
      font-weight: 700;
      margin: 0;
      letter-spacing: -0.3px;
    }

    .section-subtitle {
      font-size: 13px;
      color: $text-dark;
      display: block;
      margin-top: 4px;
      font-weight: 500;
    }
  }

  /* Document Card */
  .document-card {
    background: $white;
    border: 1px solid rgba($navy, 0.1);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    animation: cardFadeIn 0.6s ease-out both;

    &:hover {
      box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
      border-color: rgba($navy, 0.2);
      transform: translateY(-4px);
    }

    .document-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 18px;
      background: linear-gradient(135deg,
          rgba($navy, 0.02) 0%,
          rgba($aqua, 0.02) 100%);
      border-bottom: 2px solid rgba($navy, 0.08);

      .document-info {
        display: flex;
        align-items: center;
        gap: 12px;
        flex: 1;

        .document-icon {
          font-size: 32px !important;
          flex-shrink: 0;

          &.lgb-icon {
            color: #ff6b6b;
          }

          &.cert-icon {
            color: #4ecdc4;
          }

          &.list-icon {
            color: #95e1d3;
          }
        }

        .document-text {
          .document-title {
            font-size: 16px;
            font-weight: 700;
            color: $text-black;
            margin: 0 0 4px 0;
            letter-spacing: -0.2px;
          }

          .document-subtitle {
            font-size: 12px;
            color: $text-dark;
            margin: 0;
            font-weight: 500;
          }
        }
      }

      .view-btn {
        flex-shrink: 0;
        transition: all 0.3s ease;

        &:hover {
          transform: scale(1.15);
        }
      }
    }

    .document-divider {
      height: 1px;
      background: linear-gradient(90deg,
          transparent 0%,
          rgba($navy, 0.1) 50%,
          transparent 100%);
    }

    .upload-zone {
      padding: 24px;
      background: $white;
      position: relative;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      border: 2px dashed rgba($navy, 0.15);
      border-radius: 8px;
      margin: 16px;
      cursor: pointer;
      pointer-events: all;

      &.drag-active {
        background: linear-gradient(135deg,
            rgba($navy, 0.08) 0%,
            rgba($aqua, 0.08) 100%);
        border-color: $navy;
        border-width: 3px;
        box-shadow: inset 0 0 20px rgba($navy, 0.15), 0 0 20px rgba($navy, 0.1);
        transform: scale(1.02);

        .upload-icon {
          color: $navy !important;
          animation: bounce 0.6s ease-in-out infinite;
        }

        .upload-title {
          color: $navy;
        }
      }

      .file-input-hidden {
        display: none;
      }

      .upload-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        text-align: center;
        cursor: pointer;
        padding: 12px;
        pointer-events: auto;

        .upload-icon {
          font-size: 48px !important;
          color: #9ca3af;
          transition: all 0.3s ease;
        }

        .upload-title {
          font-size: 16px;
          font-weight: 700;
          color: $text-black;
          margin: 0;
          letter-spacing: -0.3px;
          transition: all 0.3s ease;
        }

        .upload-subtitle {
          font-size: 13px;
          color: $text-dark;
          margin: 0;
          font-weight: 500;
        }

        .upload-hint {
          font-size: 11px;
          color: #9ca3af;
          margin: 8px 0 0 0;
          font-style: italic;
        }
      }

      .file-preview {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 16px;
        background: linear-gradient(135deg,
            rgba(#10b981, 0.08) 0%,
            rgba(#10b981, 0.02) 100%);
        border-radius: 8px;
        margin-top: 12px;
        border: 1px solid rgba(#10b981, 0.2);
        animation: slideUp 0.4s ease-out;

        .preview-icon {
          font-size: 28px !important;
          color: #10b981;
          flex-shrink: 0;
        }

        .preview-name {
          flex: 1;
          font-size: 13px;
          font-weight: 600;
          color: $text-black;
          word-break: break-word;
          line-height: 1.4;
        }

        .preview-size {
          font-size: 11px;
          color: $text-dark;
          background: rgba($navy, 0.08);
          padding: 4px 8px;
          border-radius: 4px;
          flex-shrink: 0;
        }

        .remove-icon {
          font-size: 20px !important;
          color: #ef4444;
          cursor: pointer;
          transition: all 0.3s ease;
          flex-shrink: 0;

          &:hover {
            transform: scale(1.2) rotate(90deg);
            color: #b91c1c;
          }
        }
      }
    }

    .upload-action {
      padding: 16px;
      background: linear-gradient(180deg,
          transparent 0%,
          rgba(0, 0, 0, 0.02) 100%);
      border-top: 1px solid rgba($navy, 0.08);

      .upload-btn {
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        font-size: 13px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

        &:hover:not(:disabled) {
          transform: translateY(-3px);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
        }

        &:active:not(:disabled) {
          transform: translateY(-1px);
        }
      }
    }
  }

  /* Table Wrapper */
  .table-wrapper {
    background: $white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba($navy, 0.1);
    animation: fadeIn 0.6s ease-out;

    .professional-table {
      background: transparent !important;

      ::v-deep {
        .table-header {
          background: linear-gradient(135deg, $navy 0%, $aqua 100%);

          .table-header-cell {
            color: $white !important;
            font-weight: 700;
            font-size: 13px;
            padding: 14px !important;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            border-bottom: 2px solid rgba($white, 0.2) !important;
          }
        }

        tbody {
          tr {
            transition: all 0.3s ease;
            border-bottom: 1px solid rgba($navy, 0.08);

            &.even-row {
              background-color: rgba($navy, 0.02);
            }

            &:hover {
              background-color: rgba($aqua, 0.06);
              transform: scaleX(1.01);
              transform-origin: center;
            }

            .table-cell {
              padding: 14px !important;
              color: $text-dark;
              font-size: 13px;
              line-height: 1.6;
            }
          }
        }
      }
    }
  }

  /* Subscription Section */
  .subscription-section {
    margin-top: 32px;
    padding-top: 32px;
    border-top: 2px dashed rgba($navy, 0.15);
  }

  /* Approval Section */
  .approval-section {
    padding: 24px;

    .approval-header {
      display: flex;
      align-items: center;
      gap: 20px;
      padding: 24px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 12px;
      margin-bottom: 32px;
      box-shadow: 0 10px 30px rgba(102, 126, 234, 0.15);

      .header-icon {
        color: white;
        font-size: 40px !important;
      }

      .header-content {
        color: white;

        .header-title {
          font-size: 24px;
          font-weight: 700;
          margin: 0 0 4px 0;
          letter-spacing: -0.5px;
        }

        .header-subtitle {
          font-size: 14px;
          opacity: 0.9;
          margin: 0;
          font-weight: 500;
        }
      }
    }

    .form-section {
      background: #ffffff;
      padding: 24px;
      border-radius: 12px;
      margin-bottom: 24px;
      border: 1px solid #e5e7eb;
      transition: all 0.3s ease;

      &:hover {
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        border-color: #d1d5db;
      }
    }

    .form-field-wrapper {
      .form-label {
        display: block;
        font-size: 13px;
        font-weight: 600;
        color: #1f2937;
        margin-bottom: 8px;
        text-transform: uppercase;
        letter-spacing: 0.5px;

        .required-indicator {
          color: #ef4444;
          margin-right: 4px;
          font-weight: 700;
        }
      }

      .premium-textfield {
        ::v-deep .v-field__outline {
          color: #e5e7eb !important;
        }

        ::v-deep .v-input__control {

          input,
          textarea {
            font-size: 14px !important;
            font-weight: 500 !important;
            color: #374151 !important;

            &::placeholder {
              color: #9ca3af !important;
            }
          }
        }

        ::v-deep .v-field:hover {
          .v-field__outline {
            color: #d1d5db !important;
          }
        }

        ::v-deep .v-field.v-field--focused {
          .v-field__outline {
            color: #8950fc !important;
          }
        }

        ::v-deep .v-field__prepend-inner {
          color: #8950fc !important;
        }
      }

      .date-info-box {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        background: #eff6ff;
        padding: 12px;
        border-radius: 8px;
        margin-bottom: 12px;
        border-left: 3px solid #3b82f6;

        .info-icon {
          color: #3b82f6;
          flex-shrink: 0;
          margin-top: 2px;
        }

        .info-text {
          font-size: 12px;
          color: #1e40af;
          margin: 0;
          font-weight: 500;
        }
      }
    }

    .action-section {
      padding: 32px 24px 24px;
      background: linear-gradient(180deg, #f9fafb 0%, #f3f4f6 100%);
      border-radius: 12px;
      margin-top: 32px;
      border: 1px solid #e5e7eb;

      .button-group {
        display: flex;
        gap: 12px;
        justify-content: center;
        flex-wrap: wrap;
        align-items: center;

        .action-btn {
          font-weight: 600;
          font-size: 14px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

          &:hover:not(:disabled) {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
          }

          &:active:not(:disabled) {
            transform: translateY(0);
          }

          &.approve-btn {
            color: white !important;
            background: linear-gradient(135deg,
                #10b981 0%,
                #059669 100%) !important;

            &:hover:not(:disabled) {
              background: linear-gradient(135deg,
                  #059669 0%,
                  #047857 100%) !important;
            }
          }

          &.reject-btn {
            color: white !important;
            background: linear-gradient(135deg,
                #ef4444 0%,
                #dc2626 100%) !important;

            &:hover:not(:disabled) {
              background: linear-gradient(135deg,
                  #dc2626 0%,
                  #b91c1c 100%) !important;
            }
          }

          &.cancel-btn {
            color: #6b7280 !important;
            border: 2px solid #d1d5db !important;
            background: white !important;

            &:hover:not(:disabled) {
              background: #f3f4f6 !important;
              border-color: #9ca3af !important;
            }
          }
        }
      }
    }
  }

  // Responsive adjustments
  @media (max-width: 960px) {
    .approval-section {
      padding: 16px;

      .approval-header {
        flex-direction: column;
        text-align: center;
        padding: 16px;

        .header-icon {
          font-size: 32px !important;
        }

        .header-content {
          .header-title {
            font-size: 20px;
          }
        }
      }

      .action-section {
        .button-group {
          flex-direction: column;

          .action-btn {
            width: 100%;
            min-width: auto;
          }
        }
      }
    }
  }

  /* Form Inputs */
  .form-label {
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: $text-dark;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;

    .text-danger {
      color: #e53935;
    }

    .form-hint {
      font-size: 11px;
      color: $text-dark;
      margin-top: 4px;
      margin-bottom: 0;
      text-transform: none;
    }
  }

  .form-input {
    ::v-deep {
      .v-input__control {
        .v-input__slot {
          background: rgba($white, 0.8);
          border-radius: 8px;

          input {
            color: $text-black;
            font-weight: 500;

            &::placeholder {
              color: rgba($text-dark, 0.5);
            }
          }
        }
      }

      &.v-text-field--outlined {
        fieldset {
          border-color: rgba($navy, 0.2) !important;
          transition: all 0.3s ease;
        }

        &:hover fieldset {
          border-color: rgba($navy, 0.4) !important;
        }

        &.v-input--is-focused fieldset {
          border-color: $navy !important;
          border-width: 2px;
        }
      }
    }
  }

  /* Action Buttons */
  .button-row {
    margin-top: 32px;
    padding-top: 24px;
    border-top: 1px solid rgba($navy, 0.1);
    display: flex;
    gap: 12px;
    justify-content: center;
    flex-wrap: wrap;
  }

  .action-approve-btn {
    background: linear-gradient(135deg, $seaform 0%, $aqua 100%) !important;
    color: $white !important;
    border-radius: 8px;
    padding: 12px 32px !important;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 13px;
    letter-spacing: 0.5px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 12px rgba($seaform, 0.3);
    min-width: 140px;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba($seaform, 0.4);
    }

    &:active {
      transform: translateY(0);
    }
  }

  .action-reject-btn {
    background: linear-gradient(135deg, #e53935 0%, #d32f2f 100%) !important;
    color: $white !important;
    border-radius: 8px;
    padding: 12px 32px !important;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 13px;
    letter-spacing: 0.5px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 12px rgba(#e53935, 0.3);
    min-width: 140px;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(#e53935, 0.4);
    }
  }

  .action-cancel-btn {
    background: linear-gradient(135deg,
        $text-dark 0%,
        $text-black 100%) !important;
    color: $white !important;
    border-radius: 8px;
    padding: 12px 32px !important;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 13px;
    letter-spacing: 0.5px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 12px rgba($text-black, 0.2);
    min-width: 140px;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba($text-black, 0.3);
    }
  }

  /* Animations */
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-30px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateX(-20px);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes bounceIn {
    0% {
      opacity: 0;
      transform: scale(0.3);
    }

    50% {
      opacity: 1;
      transform: scale(1.05);
    }

    70% {
      transform: scale(0.9);
    }

    100% {
      transform: scale(1);
    }
  }

  @keyframes cardFadeIn {
    from {
      opacity: 0;
      transform: translateY(10px) scale(0.95);
    }

    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }

  @keyframes bounce {

    0%,
    100% {
      transform: translateY(0);
    }

    50% {
      transform: translateY(-8px);
    }
  }

  /* Responsive Design */
  @media (max-width: 768px) {
    .premium-header {
      padding: 16px;

      .header-content {
        flex-direction: column;
        gap: 16px;

        .title-section {
          width: 100%;

          .header-title {
            font-size: 20px;
          }
        }

        .action-buttons {
          width: 100%;
          justify-content: center;
        }
      }
    }

    .info-card {
      margin-bottom: 16px;
    }

    .button-row {
      flex-direction: column;

      .action-approve-btn,
      .action-reject-btn,
      .action-cancel-btn {
        width: 100%;
      }
    }

    .reupload-section-header {
      flex-direction: column;
      text-align: center;

      .section-icon {
        font-size: 28px !important;
      }

      .section-title {
        font-size: 18px;
      }
    }

    .document-card {
      .document-header {
        flex-direction: column;
        align-items: flex-start;

        .view-btn {
          align-self: flex-end;
        }
      }

      .upload-zone {
        .upload-content {
          .upload-icon {
            font-size: 40px !important;
          }

          .upload-title {
            font-size: 14px;
          }
        }
      }
    }
  }

  @media (max-width: 480px) {
    .reupload-section-header {
      padding: 16px;

      .section-title {
        font-size: 16px;
      }

      .section-subtitle {
        font-size: 12px;
      }
    }

    .document-card {
      .document-header {
        padding: 12px;

        .document-icon {
          font-size: 28px !important;
        }

        .document-text {
          .document-title {
            font-size: 14px;
          }

          .document-subtitle {
            font-size: 11px;
          }
        }
      }

      .upload-zone {
        margin: 12px;
        padding: 16px;

        .upload-content {
          gap: 6px;

          .upload-icon {
            font-size: 36px !important;
          }

          .upload-title {
            font-size: 13px;
          }

          .upload-subtitle {
            font-size: 12px;
          }

          .upload-hint {
            font-size: 10px;
          }
        }

        .file-preview {
          flex-wrap: wrap;
          gap: 8px;

          .preview-name {
            font-size: 12px;
            flex-basis: 100%;
          }
        }
      }

      .upload-action {
        padding: 12px;

        .upload-btn {
          font-size: 12px;
        }
      }
    }
  }

  /* Loading State */
  ::v-deep .v-overlay {
    background: rgba($text-black, 0.5);
  }
}
</style>